<template>
    <div v-click-outside="reset" class="scc-select" :class="[inverted ? 'scc-select--inverted' : 'big-pp']">
        <button class="scc-select__selected" @click="showOptions">
            {{ options[selected].label }}
            <svg xmlns="http://www.w3.org/2000/svg" width="10.971" height="7.147" viewBox="0 0 10.971 7.147">
                <path
                    id="Path_1979"
                    data-name="Path 1979"
                    d="M8598.658,1748.035l4.854,5,4.668-5"
                    transform="translate(-8597.94 -1747.339)"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                />
            </svg>
        </button>
        <ul v-show="isShowingOptions" class="scc-select__options" role="listbox" tabindex="-1">
            <li
                v-for="(option, index) in options"
                :key="index"
                class="scc-select__option"
                role="option"
                @click="selectHandler(option.value)"
            >
                {{ option.label }}
            </li>
        </ul>
    </div>
</template>

<script>
import './scc-select.scss';

export default {
    name: 'SccSelect',
    directives: {
        'click-outside': {
            bind: function(el, binding) {
                // Define Handler and cache it on the element
                const bubble = binding.modifiers.bubble;
                const handler = e => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e);
                    }
                };
                el.__vueClickOutside__ = handler;

                // add Event Listeners
                document.addEventListener('click', handler);
            },
        },
    },
    props: {
        value: {
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        inverted: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            selected: 0,
            isShowingOptions: false,
        };
    },
    methods: {
        selectHandler(val) {
            const index = this.options.findIndex(x => x.value === val);
            if (index || index === 0) {
                this.selected = index;
            }
            this.$emit('input', val);
            this.isShowingOptions = false;
        },
        showOptions() {
            this.isShowingOptions = !this.isShowingOptions;
        },
        reset() {
            this.isShowingOptions = false;
        },
    },
};
</script>
